<template>
  <div>
    <v-container>
      <h1 class="primary--text font-weight-bold pb-4">
        {{
          isEditLandlordValidityPlan
            ? $t("settings.landlordValidityPlan.updatePlan")
            : $t("settings.landlordValidityPlan.newPlan")
        }}
      </h1>
      <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
        <form v-on:submit.prevent="handleSubmit(onSave)" :key="reRender">
          <v-row align="center">
            <v-col cols="12" sm="6" md="6" class="py-0 pt-6">
              <ValidationProvider v-slot="{ errors }" rules="required">
                <v-text-field
                  outlined
                  :error-messages="errors"
                  dense
                  :label="`${$t('settings.landlordValidityPlan.planName')}`"
                  color="secondary"
                  type="text"
                  v-model="landlordValidityPlanModelObj.planName"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("settings.landlordValidityPlan.planName") }}
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="6" md="6" class="py-0 pt-6">
              <ValidationProvider v-slot="{ errors }" rules="required">
                <v-text-field
                  outlined
                  :error-messages="errors"
                  type="number"
                  min="1"
                  dense
                  :label="`${$t('settings.landlordValidityPlan.price')}`"
                  color="secondary"
                  v-model="landlordValidityPlanModelObj.price"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("settings.landlordValidityPlan.price") }}
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="6" md="6" class="py-0 pt-6">
              <ValidationProvider v-slot="{ errors }" rules="required">
                <v-text-field
                  outlined
                  :error-messages="errors"
                  type="number"
                  min="1"
                  dense
                  :label="`${$t('settings.landlordValidityPlan.validity')}`"
                  color="secondary"
                  v-model="landlordValidityPlanModelObj.validity"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("settings.landlordValidityPlan.validity") }}
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="6" md="6" class="py-0 pt-6">
              <ValidationProvider v-slot="{ errors }" rules="required">
                <v-text-field
                  outlined
                  :error-messages="errors"
                  type="number"
                  min="1"
                  dense
                  :label="`${$t('settings.landlordValidityPlan.noOfRooms')}`"
                  color="secondary"
                  v-model="landlordValidityPlanModelObj.numberOfUnits"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("settings.landlordValidityPlan.noOfRooms") }}
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" class="py-0">
              <ValidationProvider v-slot="{ errors }" rules="required">
                <v-autocomplete
                  v-model="landlordValidityPlanModelObj.currency"
                  :error-messages="errors"
                  :items="currencyItems"
                  item-text="currency"
                  item-value="currency"
                  outlined
                  dense
                  :label="$t('settings.landlordValidityPlan.currency')"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("settings.landlordValidityPlan.currency") }}
                  </template>
                </v-autocomplete>
              </ValidationProvider>
            </v-col>
            <v-col cols="9" sm="9" md="9" class="py-0 mx-auto">
              <!-- <div class="d-flex justify-space-around"> -->
              <v-btn
                width="100%"
                class="white--text rounded-lg"
                color="primary"
                type="submit"
                :loading="btnLoading"
              >
                {{
                  isEditLandlordValidityPlan
                    ? $t("common.update")
                    : $t("common.save")
                }}
              </v-btn>
              <!-- </div> -->
            </v-col>
            <v-col v-if="isError != null" cols="12" sm="12">
              <Alert :message="isError" />
            </v-col>
          </v-row>
        </form>
      </ValidationObserver>
    </v-container>
  </div>
</template>
<script>
import "@/core/methods/validation_rules";
import { mapGetters } from "vuex";
import { createLandlordValidityPlan } from "../../methods/landlord_validity_plan/create_landlord_validity_plan";
import { updateLandlordValidityPlan } from "../../methods/landlord_validity_plan/update_landlord_validity_plan";
export default {
  data() {
    return {
      reRender: 0,
      currency: "",
      currencyItems: [],
      btnLoading: false,
      landlordValidityPlanModelObj: {
        planName: "",
        validity: "",
        price: "",
        numberOfUnits: "",
        currency: ""
      },
      isError: null
    };
  },
  components: {
    Alert: () => import("@/core/components/Alert.vue")
  },
  mounted() {
    if (this.isEditLandlordValidityPlan)
      this.landlordValidityPlanModelObj = this.$format.cloneVariable(
        this.editLandlordValidityPlan
      );
  },
  computed: {
    ...mapGetters(["isEditLandlordValidityPlan", "editLandlordValidityPlan"])
  },
  apollo: {
    getAllCurrencyForAdmin() {
      this.loading = true;
      return {
        query: require("@/settings/api/queries/currency/get_all_currencies.graphql"),
        variables: {
          input: {
            limit: 0,
            skip: 0
          },
          filter: {
            searchKey: this.search
          }
        },
        result({ data, loading }) {
          // , loading, networkStatus, refetch
          const filteredCurrencies = [];
          data.getAllCurrencyForAdmin.currencies.forEach(currency => {
            if (currency.isActive) {
              filteredCurrencies.push(currency);
            }
          });
          this.currencyItems = filteredCurrencies;
          this.loading = loading;
        }
      };
    }
  },
  watch: {
    isEditLandlordValidityPlan: {
      handler() {
        if (this.isEditLandlordValidityPlan) {
          this.landlordValidityPlanModelObj = this.$format.cloneVariable(
            this.editLandlordValidityPlan
          );
        } else {
          this.landlordValidityPlanModelObj = {
            planName: "",
            price: "",
            validity: "",
            numberOfUnits: "",
            currency: ""
          };
          this.reRender++;
        }
      },
      deep: true
    }
  },
  methods: {
    async onSave() {
      this.btnLoading = true;
      const input = {
        input: this.$format.cloneVariable(this.landlordValidityPlanModelObj)
      };
      if (!this.isEditLandlordValidityPlan) {
        const CreateInput = {
          input: {
            planName: input.input.planName,
            price: parseFloat(input.input.price),
            validity: parseInt(input.input.validity),
            numberOfUnits: parseInt(input.input.numberOfUnits),
            currency: input.input.currency
          }
        };
        createLandlordValidityPlan(CreateInput).then(response => {
          if (response.data) {
            this.btnLoading = false;
            this.$root.$emit("refetchLandlordValidityPlan");
            this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
            this.$root.$emit("snackbar", {
              snackbar: true,
              text: this.$t("common.saveSuccess"),
              color: "green"
            });
            this.landlordValidityPlanModelObj = {};
            this.reRender++;
          }
          if (response.graphQLErrors) {
            this.btnLoading = false;
            this.isError = response.graphQLErrors[0].message;
            setTimeout(() => {
              this.isError = null;
            }, 5000);
          }
        });
      } else {
        const updateInput = {
          id: input.input._id,
          input: {
            planName: input.input.planName,
            price: parseFloat(input.input.price),
            validity: parseInt(input.input.validity),
            numberOfUnits: parseInt(input.input.numberOfUnits),
            currency: input.input.currency
          }
        };
        updateLandlordValidityPlan(updateInput).then(response => {
          if (response.data) {
            this.$root.$emit("refetchLandlordValidityPlan");
            this.btnLoading = false;
            this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
            this.$store.commit("IS_EDIT_LANDLORD_VALIDITY_PLAN", false);
            this.$root.$emit("snackbar", {
              snackbar: true,
              text: this.$t("common.updateSuccess"),
              color: "green"
            });
          }
          if (response.graphQLErrors) {
            this.btnLoading = false;
            this.isError = response.graphQLErrors[0].message;
          }
        });
      }
    },
    onCancel() {
      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
      this.$store.commit("IS_EDIT_LANDLORD_VALIDITY_PLAN", false);
    }
  }
};
</script>
